// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1EWcP","gfeWrapper":"CalendarEvent_gfeWrapper__2Rc0W"};